import logoHeader from "@/assets/logo-header.png";
import logoHeader2x from "@/assets/logo-header@2x.png";
import { Link } from "react-router-dom";

export const AppLogo = () => {
  return (
    <Link to="/">
      <img
        src={logoHeader}
        srcSet={`${logoHeader} 1x, ${logoHeader2x} 2x`}
        alt="Logo EGS"
      />
    </Link>
  );
};
